/* eslint-disable import/prefer-default-export */
import type { LoaderAction } from './types';

export const setLoader = (loaderVisible: boolean): LoaderAction => ({
  type: 'SET_LOADER',
  payload: loaderVisible,
});
